import { observer } from "mobx-react";
import * as React from "react";
import { Route, RouteChildrenProps, Switch } from "react-router";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { doctorStore } from "../../../stores/DoctorStore";
import { StandardContainer } from "../../containers/StandardContainer";
import { history } from "../../routers/history";
import { Routes } from "../../routers/Routes";
import { UserNavigation } from "../../ui/UserNavigation";
import { Colors } from "../../util/Colors";
import { Icon } from "../../util/Icon";
import { MedicationCheck } from "../shared/components/MedicationCheck";
import { MedicationGroups } from "../shared/components/MedicationGroups";

const NavigationHeading = styled.h4`
    margin-left: 32px;
`;

const BackContainer = styled.div`
    display: flex;
    align-items: center;
`;

type IParams = {
    uid?: string;
};

type IProps = RouteChildrenProps<IParams>;

export const MedicationSite = observer(({ match }: IProps) => {
    const uid = match?.params.uid;
    const isLoading = !doctorStore.selectedPatient || doctorStore.selectedPatient?.uid !== uid;

    React.useEffect(() => {
        if ((!doctorStore.selectedPatient || doctorStore.selectedPatient?.uid !== uid) && uid) {
            doctorStore.loadPatient(uid);
        }
    }, [uid]);

    if (isLoading) {
        return null;
    }

    return (
        <>
            <UserNavigation
                leftComponent={
                    <BackContainer>
                        <Link to={Routes.DOCTOR.ROOT}>
                            <Icon name="arrowLeft" hoverColor={Colors.secondary} />
                        </Link>
                        <NavigationHeading>
                            {doctorStore.selectedPatient?.lastname} {doctorStore.selectedPatient?.firstname}
                        </NavigationHeading>
                    </BackContainer>
                }
            />
            <StandardContainer>
                <Switch>
                    <Route path={Routes.DOCTOR.MEDICATION_GROUPS} component={MedicationGroups} />
                    <Route path={Routes.DOCTOR.MEDICATION_CHECK} component={MedicationCheck} />
                </Switch>
            </StandardContainer>
        </>
    );
});
